module.exports = __webpack_public_path__ + "static/media/vstup.63234167.jpg";